import { ClerkRoot } from "./auth/ClerkRoot";
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { getPartnerAppName } from './utils/partnerApp';
import './index.css';

document.title = getPartnerAppName();

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ClerkRoot><App /></ClerkRoot>
  </React.StrictMode>,
);